module.exports = __webpack_public_path__ + "img/gift_jbl_tt_es.e44a277b.jpg";